import type { HTMLAttributes, ReactNode } from "react";

export interface DatePillProps extends HTMLAttributes<HTMLSpanElement> {
  /** Marque la pastille comme urgente (fond rust + texte blanc) — réserver
   *  aux dates impératives (échéance déclarative dépassée, alerte). */
  urgent?: boolean;
  children?: ReactNode;
}

/**
 * Petite pastille mono pour afficher une date courte ("3 mai", "J−12").
 * Variante urgent = rouge-rust pour les échéances impératives.
 */
export function DatePill({ urgent = false, className = "", children, ...rest }: DatePillProps) {
  const composed = ["ui-date-pill", urgent ? "urgent" : "", className].filter(Boolean).join(" ");
  return (
    <span className={composed} {...rest}>
      {children}
    </span>
  );
}
